import GMap from "google-map-react"
import React, { FC } from "react"
import { Icon } from "react-icons-kit"
import { iosLocation } from "react-icons-kit/ionicons/iosLocation"
import { Box } from "rebass"
import { googleMapKey } from "../lib/config"

const GoogleMap = ({
  markers = [],
  defaultCenter = { lat: 37.923876, lng: 23.920351 },
  defaultZoom = 11,
  mapHeight = "500px",
  handleCityModal,
}) => {
  return (
    <Box
      width={1}
      css={`
        height: ${mapHeight};
        // border-radius: 12px;
        // overflow: hidden;
      `}
    >
      <GMap
        bootstrapURLKeys={{ key: googleMapKey }}
        defaultCenter={defaultCenter}
        defaultZoom={defaultZoom}
        options={{ fullscreenControl: false }}
      >
        {markers.map((marker, i) => (
          <Marker
            key={i}
            lat={Number(marker.coordinates.latitude)}
            lng={Number(marker.coordinates.longitude)}
            city={marker}
            onClick={() => {
              handleCityModal(marker)
              // setSelectedCity(marker)
              // setModalVisible(true)
            }}
          />
        ))}
      </GMap>
    </Box>
  )
}

export default GoogleMap

type MarkerProps = {
  lat: number
  lng: number
  city: any
  onClick?: () => void
}

export const Marker: FC<MarkerProps> = ({ city, onClick }) => (
  <div
    onClick={onClick}
    css={`
      white-space: nowrap;
      cursor: pointer;
      span {
        display: inline;
        padding: 3px;
        padding-right: 12px;
        border-radius: 16px;
        background: rgba(0, 0, 0, 0.7);
        color: #fff;
      }
    `}
  >
    <span>
      <Icon
        icon={iosLocation}
        size={24}
        css={`
          position: relative;
          top: -5px;
          color: red;
        `}
      />
      {city.name}
    </span>
  </div>
)
